import { lazy } from "react";
import Loadable from "../components/loader/Loadable";

// Render
const RSF = Loadable(
  lazy(() => import("../pages/RSF-Documentation/RSFDocumentation"))
);

const Payment = Loadable(lazy(() => import("../pages/financials/Payment")));

const Profile = Loadable(lazy(() => import("../pages/users/Profile")));

// Routing
const UserRoutes = [
  {
    path: "rsf-documentation",
    element: <RSF />,
  },
  {
    path: "payment",
    element: <Payment />,
  },
  {
    path: "profile",
    element: <Profile />,
  },
];
export default UserRoutes;
